<template>
  <div class="wrap">
          <div class="logo">
            <img src="/logo.png" alt="" >
          </div>
    <div class="headerimg">
      <img src="/headerbanner.png" alt="">
    </div>
    <div class="header">
      <div class="title">
        项目简介
      </div>
      <div class="title-detail">
        <h3>捐助2750元,</h3>
        <h3>1对1资助家庭困难孩子的学费</h3>

      </div>
      <div class="title-content">
        <p>
          2022年春天，养正幼儿园迎来了一批可爱的新学员，其中有15个小朋友来自经济有困难的家庭。这些孩子有的是父母在外地打工，常年与爷爷奶奶生活，有些孩子的父母身患疾病或者残疾无法工作，还有的孩子是单亲家庭。希望通过这次活动，为孩子们募集2022年春季学期的学费，为他们并不富裕的家庭减轻一些经济负担。
        </p>
      </div>
      <div class="num">
        <p><b style="font-weight:bold;color:#AB74B1;">募集金额：</b>每个孩子2750元，包含学费、三套校服、书包、餐费以及保险等费用。</p>
      </div>
    </div>
    <div class="banner">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item>
          <img src="/study.jfif" alt="">
        </van-swipe-item>
        <van-swipe-item>
          <img src="/banner.jfif" alt="">
        </van-swipe-item>
        <van-swipe-item>
          <img src="/banner3.jpg" alt="">
        </van-swipe-item>
        <van-swipe-item>
          <img src="/banner4.jpg" alt="">
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="wrap-content">
      <div class="student">
        <span>募集学员</span>
      </div>
      <ul  style="overflow: hidden" class="one-to-one">
        <li @click="handlerOnclick(item.psId)" v-for="(item,index) in childrenList" :key="index">
          <img :src="item.phoLink" alt="">
          <div class="wrap-text">
            <div class="wrap-text-content">
              <div class="left">
                <div class="li-username common-text">
                  <span>{{item.stuName}}</span>
                </div>
              </div>
              <div class="right">
                <span>{{item.stuAge}}</span>
                <span class="point">·</span>
                <span>{{item.stuSex}}</span>

              </div>
            </div>

            <div class="li-status" v-if="item.ordState!=1 && item.ordState!=2">
              <span>为爱认捐</span>
            </div>
            <div class="li-status-border"  v-if="item.ordState ==1">
              <span>认捐中</span>
            </div>
            <div class="li-status-dashed" v-if="item.ordState ==2">
              <div class="dashed"></div>
              <div class="donated">
                <span>{{item.nickName}}</span>
                <span style="padding-left: 6px">已认捐</span>
              </div>

            </div>
            <div class="flower" v-if="item.ordState ==2">
              <div class="li-img">
                <img src="/love.png" alt="">
              </div>
            </div>

          </div>
        </li>
      </ul>
      <div class="line">
        <span class="line-span"></span>
        <span class="line-point"></span>
        <span class="line-span"></span>
      </div>
      <div class="footer">
        <p>
          家育苑养正幼儿园是一所非盈利幼儿园，SOHO中国基金会每年补贴运营管理费。这所位于大山里的幼儿园从建设到开学，凝聚了社会各界的爱心，是一所充满美德和爱的幼儿园。目前已经有180名孩子就读。对于留守儿童和经济有困难的家庭，幼儿园会优先录取。
        </p>
        <div class="logo">
          <img src="/logo.png" alt="" >
        </div>
      </div>
    </div>
    <div class="top" @click="backTop">
      <img src="/top.png" alt="">
    </div>
  </div>
</template>

<script>
import {getdataInfo, getdataInfoUpdatePay, oneList} from '../api/index'
export default {
  name: "index",
  data(){
    return {
      childrenList:[],
      scrollTop:0,
      active: 0,
    }
  },
  mounted() {
    this.getOneList()
  },
  methods:{
    async payOnclick(){
      let data = await getdataInfoUpdatePay()
      console.log(data.data)
      window.location.href=data.data
      //window.open(data.data)
    },
    async getOneList(){
      const onelist = await oneList({proId:1})
      this.childrenList = onelist.data
      // console.log(onelist)
    },
    handlerOnclick(id){
      this.$router.push({
        path: '/detail',
        query:{id:id}
      })
    },
    backTop() {
      let that = this
      let timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
        if(that.scrollTop === 0) {
          clearInterval(timer)
        }
      }, 16)
    },
    onchange(index){
      console.log(index)
    }

  }

}
</script>

<style lang="scss" scoped>
.van-tabs__line{
  background-color: #AB74B1 !important;
}
.logo{
  position: relative;
  text-align: center;
  margin-top: 20px;
  padding-bottom: 30px;
}
.logo img{
  width: 406px;
  height: 246px;
  display: inline-block;
}
.line {
  width: 35%;
  text-align: center;
  display: flex;
  align-items: center;
  margin: 74px auto 50px;
}
.line span {
  display: block;
}
.line-span{
  width: 120px;
  display: block;
  height: 1px;
  background:#D3C4D5;

}
.line-point{
  width: 4px;
  height: 4px;

  background: #D7CFD7;
  transform: rotate(-45deg);
  margin: 0 20px;
}
.wrap-text-content{
  padding-top: 20px;
  display: flex;
  font-family: row;
  justify-content: space-around;
  align-items: center;
}
.left span{
  font-family: 'PingFang SC';
  font-style: normal;
  font-weight: 400;
  font-size: 34px;
  line-height: 153%;
  /* identical to box height, or 26px */


  color: #000000;
}
.right span{
  font-family: 'PingFang SC';
  font-style: normal;
  font-weight: 400;
  font-size: 28px;
  line-height: 153%;
  /* or 21px */


  color: #898989;
}
.right .point{
  padding: 0 10px;
}
.pay{
  text-align: center;
  width: 100%;
  height: 100px;
  line-height: 100px;
  background: red;
}
.flower{

  /*background: #DF2413;*/
  display: flex;
  vertical-align: center;
  margin: 0 auto;
  position: absolute;
  bottom: -4px;
  right: 0px;
}
.wrap ul li .flower span{
  font-size: 20px;
  color: #fff;
  letter-spacing: 1px;
  margin-left: 5px;
  color: #DF2413;
}
.wrap ul li .flower img{
  display: inline-block;
  width: 90px;
  height: 84px;
}
.header{
  padding-bottom: 40px;
}
.title{
  margin-top: 60px;
  width:100%;
  box-sizing: border-box;
  padding: 0 56px;
  height: 42px;
  line-height: 42px;
  font-size: 28px;
  color: #BBB0BC;
  font-family: 'PingFang SC'
}
.title-detail{
  width:100%;
  box-sizing: border-box;
  padding: 24px 56px 0px;
}

.title-detail h3{
  font-size: 48px;
  font-family: 'PingFang SC';
  font-style: normal;
  font-weight: 500;
  line-height: 1.5;
}
.title-content{
  width:100%;
  box-sizing: border-box;
  padding: 24px 56px 0px;
}
.title-content p{
  font-family: 'PingFang SC';
  font-style: normal;
  font-weight: 300;
  font-size: 34px;
  line-height: 56px;
  text-align: justify;
  color: #000000;
}
.num{
  width:650px;
  margin:0 auto;
  height: 200px;
  background: rgba(193, 153, 198, 0.1);
  border: 1px solid #C199C6;
  box-sizing: border-box;
  border-radius: 5px;
  margin-top: 30px;
}
.num p{
  font-style: normal;
  font-weight: 300;
  font-size: 34px;
  line-height: 164.5%;
  padding: 20px 32px 0;
  /* or 28px */

  color: #AB74B1;
}
/*.title .line{*/
/*  display: inline-block;*/
/*  width: 10px;*/
/*  height: 40px;*/
/*  background: #c996c9;*/

/*}*/
.wrap{
  width: 100%;
  position: relative;

  /*background: rgb(245,245,245);*/
}

.top{
  position: absolute;
  bottom: 40px;
  right: 40px;
  z-index: 1;
}
.top img{
  width: 76px;
  height:76px;
}
.banner{
  width: 100%;
  margin: 0 auto;
  padding-top: 20px;
  background: #fff;
}
.banner img{
  display: block;
  width: 100%;
}
.wrap-content{
  background: rgb(245,245,245);
  padding-top: 76px;
  padding-bottom: 20px;
}
.wrap-content .student{
  width: 100%;

}
.student span{
  font-family: 'PingFang SC';
  font-style: normal;
  font-weight: 400;
  font-size: 28px;
  line-height: 153%;
  display: block;
  margin-left: 40px;
  color: #BBB0BC;
}

.wrap ul{
  width: 92%;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  /*background: rgb(245,245,245);*/
}
.wrap ul li{
  width: 48%;
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 10px;
  margin-top: 20px;
  position: relative;
  padding-bottom: 30px;
  border-radius: 10px;
}

.wrap ul li img{
  border-top-right-radius:10px;
  border-top-left-radius:10px;
}
/*.wrap ul li span{*/
/*  display: block;*/
/*  font-size: 32px;*/
/*  line-height: 1.5;*/

/*}*/
.wrap .li-status{
  width: 83%;
  height: 80px;
  line-height: 80px;
  background: #c996c9;
  text-align:center;
  margin-top: 20px;
  border-radius: 10px;
  margin: 30px auto 0;
}
.wrap .li-status-dashed{
  width: 83%;
  margin: 30px auto 0;

}
.wrap .donated{
  margin-top: 20px;
}
.wrap .li-status-dashed span{
  font-family: 'PingFang SC';
  font-style: normal;
  font-weight: 400;
  font-size: 34px;
  line-height: 153%;
  /* identical to box height, or 26px */
  color: #AB74B1;
}

.dashed{
  border: 2px dashed #DDDDDD;
  position: relative;
}
/*.dashed:after{*/
/*  content: "";*/
/*  position: absolute;*/
/*  left: 0;*/
/*  right: 0;*/
/*  bottom:0px;*/
/*  height: 1px;*/
/*  background: #d8d8d8;*/
/*  -webkit-transform: scaleY(.5);*/
/*  transform: scaleY(.5);*/
/*;}*/

.wrap .li-status-border{
  width: 83%;
  height: 70px;
  line-height: 70px;
  text-align:center;
  margin-top: 20px;
  border-radius: 10px;
  margin: 30px auto 0;
  border: 0.5px solid #C199C6;
}
.wrap .li-status-border span{
  color: #C199C6;
  font-size: 34px;
}

.wrap .li-status span{
  font-size: 34px;
  color:#fff;
}
.footer{
  width: 92%;
  margin: 0 auto;
}
.footer p{
  font-family: 'PingFang SC';
  font-style: normal;
  font-weight: 400;
  font-size: 28px;
  line-height: 164.5%;
  /* or 23px */


  color: #A49BA3;
}
</style>
